import { workshopVi } from "../../i18n/workshop.vi.ts";
import { vi } from "../../i18n/vi.ts";
import { Art } from "../components/common.tsx";
import "../../styles/workshop.css";

/** Rolls laid in the kept line and the three-star target, under the level title. */
export function SilkHudLine({ rolls, target, focus }: { rolls: number; target: number; focus: boolean }) {
  return (
    <span className={`puzzle-hud__moves ${focus ? "hud-focus" : ""}`} data-testid="silk-rolls">
      <Art id="reward.gift" className="ico-inline" />
      {workshopVi.rolls(rolls)}
      <span className="puzzle-hud__target" aria-label={vi.puzzle.target(target)}>
        <Art id="icon.target" className="ico-inline" />
        {target}
      </span>
    </span>
  );
}

export function SilkStuck() {
  return (
    <p className="silk-stuck" role="status" data-testid="silk-stuck">
      {workshopVi.stuck}
    </p>
  );
}
